<template>
  <b-card no-body class="msm-sub-card mb-1" :class="{ highlight: showBadges && (this.weight ? !this.ShowWeight : false) && !hasScenarios }">
    <b-card-body class="py-0">
      <b-row class="text-center my-1 text-y-center" :class="{ highlight: showBadges && (this.weight ? !this.ShowWeight : false) && hasScenarios }">
        <!-- Status column -->
        <b-col
          class="px-2 sub-card-row"
          :class="isAccomplished ? 'text-success' : 'text-danger'"
          cols="1"
          v-if="showStatus"
        >
          <font-awesome-icon
            v-if="explorationData"
            :icon="isAccomplished ? ['far', 'check'] : ['fas', 'exclamation']"
          />
        </b-col>

        <!-- Caption / logo column -->
        <b-col class="pr-2 sub-card-row border-right">
          <span v-if="overrideCaption">
            {{ overrideCaption }}
          </span>
          <b-img
            v-else
            fluid
            :src="logoUrl"
            :style="'max-height: 36px; max-width: 90px; background-color:' + logoBackgroundColor"
          />
        </b-col>

        <!-- (No)Data column -->
        <b-col 
          class="px-0 sub-card-row"
          :class="{ 'max-w': allowToggle, 'ml-n2 pl-2': !allowToggle }"
          :cols="allowToggle ? 3 : 4"
        >
          <template v-if="hasValue">
            {{ value }}{{ valueLimiter }}
          </template>
          <template v-else>
            {{ $t('Webportal.CX.Dashboard.Exploration.NoData') }}
          </template>
        </b-col>

        <!-- Popup column -->
        <b-col
          v-if="allowToggle"
          class="px-2 max-w border-left"
          cols="1"
        >
          <font-awesome-icon
            class="clickable sub-card-row"
            :icon="['far', 'search']"
            @click="$emit('toggle-popup')"
          />
        </b-col>

        <!-- Weight Badge -->
        <b-badge pill v-if="showBadges && (this.weight ? !this.ShowWeight : false)" class="weight-badge">
          {{weight}}x
        </b-badge>
      </b-row>

      <!-- Scenarios -->
      <template v-if="hasScenarios">
        <div v-for="(scenario, index) in explorationData.Scenarios" :key="index">
          <b-row class="border-top">
            <!-- Scenario name -->
            <b-col class="mt-2 mb-n2">
              <h6>{{ scenario.Name }}</h6>
            </b-col>
          </b-row>
          <b-row style="flex-direction: row-reverse;">
            <!-- Current result -->
            <b-col class="ml-3 sub-card-row border-left">
              <b-badge class="scenario-badge" :style=" { 'background-color': $parent.getColor(scenario.Result) }">
                {{ scenario.Result }}
              </b-badge>
            </b-col>

            <!-- Previous results -->
            <b-col v-for="prev_index in 3" :key="prev_index" class="px-0 sub-card-row">
              <b-badge class="scenario-badge" :style=" { 'background-color': $parent.getColor(GetPrevScenarioResult(scenario, prev_index)) }">
                {{ GetPrevScenarioResult(scenario, prev_index) }}
              </b-badge>
            </b-col>

            <!-- Action to take -->
            <b-col
              class="px-2 sub-card-row"
              :class="scenario.IsAccomplished ? 'text-success' : 'text-danger'"
              cols="1"
            >
              <font-awesome-icon :icon="scenario.IsAccomplished ? ['far', 'check'] : ['fas', 'exclamation']" />
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";

export default {
  name: "ExplorationSubCard",
  components: {},
  props: {
    showBadges: {
      type: Boolean,
      default: false
    },
    logo: {
      type: String,
      default: null
    },
    overrideText: {
      type: String,
      default: null
    },
    logoBackgroundColor: {
      type: String,
      default: "transparent"
    },
    explorationData: {
      type: Object,
      default: () => {}
    },
    overrideShowToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ShowWeight: false
    };
  },
  computed: {
    isAccomplished: function() {
      return this.explorationData?.Threshold?.IsAccomplished === true ||
             this.explorationData?.IsAccomplished === true;
    },
    showStatus: function() {
      return !this.hasScenarios && this.hasValue;
    },
    allowToggle: function() {
      return (!this.explorationData?.Inactive && !this.hasScenarios && this.hasValue) || this.overrideShowToggle;
    },
    hasScenarios: function() {
      return !!this.explorationData?.Scenarios;
    },
    hasValue: function() {
      return this.value != null;
    },
    value: function() {
      return this.explorationData?.Threshold?.Value != null ?
             this.explorationData?.Threshold?.Value :
             this.explorationData?.Result;
    },
    valueLimiter: function() {
      return this.explorationData?.Threshold?.MaxRating !== 100 &&
              this.explorationData?.ExternalSurveyId == null
        ? "/" + this.explorationData.Threshold.MaxRating
        : "%";
    },
    weight: function() {
      if (this.hasValue)
        return this.explorationData?.Threshold?.Weight ||
               this.explorationData?.Weight || 0;
      else
        return this.explorationData?.Threshold?.Weight_NoData ||
               this.explorationData?.Weight_NoData || 0;
    },
    logoUrl: function() {
      if (this.logo) {
        return this.logo.includes('static') ? `${process.env.BASE_URL}${this.logo}` : `${process.env.BASE_URL}static/${this.logo}`;
      }

      let imgId = this.explorationData?.ExtLogoId;
      return imgId ? `${process.env.BASE_URL}api/media/image?id=${imgId}` : null;
    },
    overrideCaption: function() {
      // The override text has the highest priority
      const overrideText = this.overrideText || this.explorationData?.OverrideText;
      return overrideText || // Show 'N / A', if no logo and no text was specified
        (this.logoUrl ? null : (this.explorationData?.SurveyTitle || this.$t('Webportal.CX.Dashboard.Exploration.NoData')));
    }
  },
  methods: {
    GetPrevScenarioResult(scenario, index) {
      const result = _.find(scenario?.Previous, { Position: index })?.Result;
      return result != null ? result : '--';
    }
  }
};
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";


.msm-sub-card {
  /* inherits from msm-card */
  /* box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12); */
  /* width: 100%;
  min-width: 100%; */
}
.highlight {
  box-shadow: inset 0 0px 6px #01DF74;  
}
.weight-badge {  
  background-color: #DF013A;
  color:#ffffff;
  position: absolute;
  top: -1rem;
  right: -1rem;
  font-size: 15px;
}
.scenario-badge {
  font-size: 15px;
  font-weight: 700;
  color: #000000;
}
.sub-card-row {
  min-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.max-w {
  max-width: 55px;
}

.border-left {
  border-left: 1px solid lightgrey;
}
.border-right {
  border-right: 1px solid lightgrey;
}
.border-top {
  border-top: 1px solid lightgrey;
}
.border-bottom {
  border-bottom: 1px solid lightgrey;
}
</style>
